export const GAME_NAME = 'I Notice, I Feel, I Can';

export const TRACK_SCREENS = {
  LOAD: '2 Loading Screen',
  TITLE: '1 Title Screen',
  MENU: '3 Menu Screen ',
  TOOLBOX: '33 Toolbox Menu Screen ',
  playdate1: {
    ROUND_NAME: 'Playdate Blocks',
    INTRO: '4 Blocks Intro Screen',
    CHECK: '5 Abby I Notice Screen',
    NOTICE: '7 Elmo I Notice Screen',
    FEEL: '8 Elmo I Feel Screen',
    INTERACTION1: '9 Star Breathing Screen',
    OUTRO: '10 Blocks Conclusion Screen',
  },
  party: {
    ROUND_NAME: 'Party',
    INTRO: '11 Party Intro Screen',
    CHECK: '12 Elmo I Notice Smiling Screen',
    NOTICE: '14 Big Bird I Notice Breathing Screen',
    FEEL: '15 Big Bird I Feel Nervous Screen',
    INTERACTION1: '16 Song Selection Screen',
    INTERACTION2: '17 Humming Screen',
    OUTRO: '18 Party Conclusion Screen',
  },
  playdate2: {
    ROUND_NAME: 'Playdate Thunderstorm',
    INTRO: '19 Thunderstorm Intro Screen',
    CHECK: '20 Abby I Notice Still Screen',
    NOTICE: '22 Elmo I Notice Butterflies Screen',
    FEEL: '23 Elmo I Feel Scared Screen',
    INTERACTION1: '9 Star Breathing Screen',
    OUTRO: '24 Thunderstorm Conclusion',
  },
  school: {
    ROUND_NAME: 'School Drop-Off',
    INTRO: '25 Drop-Off intro Screen',
    CHECK: '26 Big Bird I Notice Energy Screen',
    NOTICE: '28 Abby I Notice Frowning Screen',
    FEEL: '29 Abby I Feel Sad Screen',
    INTERACTION1: '30 Animal Selection Screen',
    INTERACTION2: '31 Animal Stretching Screen',
    OUTRO: '32 Drop-Off Conclusion Screen',
  },
};

export const TRACK_CHARACTERS = {
  elmo: 'Playdate Blocks',
  abby: 'Abby Cadabby',
  big_bird: 'Big Bird',
};

export const TRACK_COMPONENTS = {
  NOTICE: { componentType: 'Look and Find', componentName: 'I Notice' },
  CHOOSE: { componentType: 'MCQ', componentName: 'Choose Feeling' },
  STAR_BREATHING: { componentType: 'Trace', componentName: 'Star Breathing' },
  HUMALONG: { componentType: 'Simulation', componentName: 'Humming' },
  PLAYFUL_STRETCHING: { componentType: 'Simulation', componentName: 'Animal Stretching' },
};

export const TRACK_EVENTS = {
  GAME_PLAY: 'gamePlay',
  GAME_TIMEOUT_PLAY: 'gameTimeoutPlay',
  GAME_TIMEOUT_REENGAGE: 'gameTOReEngage',
  GAME_COMPONENT_START: 'gameComponentStart',
  GAME_COMPONENT_COMPLETE: 'gameComponentComplete',
  GAME_ROUND_START: 'gameRoundStart',
  GAME_ROUND_COMPLETE: 'gameRoundComplete',
  GAME_PLAYTHROUGH_COMPLETE: 'gamePlaythroughComplete',
  GAME_QUIT: 'gameQuit',
  GAME_MENU_CLICK: 'gameMenuClick',
  GAME_QUESTION_CA: 'gameQuestionCA',
  GAME_QUESTION_WA: 'gameQuestionWA',
  // GAME_INTERACTION: 'gameInteraction',
};
